module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.eot";


//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/font-awesome/fonts/fontawesome-webfont.eot
// module id = 1075
// module chunks = 20